import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import { getBrandName, getDescription } from '../../selectors'
import BrandDetailAndMarketingSpotligh from './BrandDetailAndMarketingSpotligh'
import { branch, renderNothing, compose } from 'recompose'

const withHideIfNoDescription = branch(
  ({ description }) => !description,
  renderNothing
)

const mapStateToProps = state => {
  const brandName = getBrandName(state)

  return {
    title: `About ${brandName} Tires`,
    description: getDescription(state)
  }
}

export default compose(
  withType({ type: 'BrandDetailAndMarketingSpotligh', placeholders: ['brandMarketingContent']}),
  connect(mapStateToProps),
  withHideIfNoDescription
)(BrandDetailAndMarketingSpotligh)
